import { Stack, Typography } from "@mui/material";

interface IProps {
  header: string;
  content?: string;
  value: string;
}

export function DataPresentation({ header, content, value }: IProps) {
  return (
    <Stack direction="column" spacing={1} mb={2}>
      <Typography variant="body2" fontWeight={600} fontSize={14} color="primary800.main">
        {header}
      </Typography>
      <Stack direction="row" spacing={1}>
        {content && (
          <Typography variant="body1" color="neutral1000.main" fontWeight={500}>
            {content}
          </Typography>
        )}
        <Typography variant="body1" color="neutral1000.main" fontWeight={500}>
          {value}
        </Typography>
      </Stack>
    </Stack>
  );
}
